import React, { Component, createRef } from "react";
import { Transition } from "react-transition-group";

const transitionClasses = {
  entering: "",
  entered: " show",
  exiting: "",
  exited: "",
};

class Modal extends Component {
  constructor(props) {
    super(props);
    this.modalRef = createRef();
  }

  componentDidMount() {
    document.addEventListener("keydown", this.props.onClose, false);
  }
  componentWillUnmount() {
    document.removeEventListener("keydown", this.props.onClose, false);
  }
  render() {
    return (
      <Transition in={this.props.show} timeout={150} unmountOnExit nodeRef={this.modalRef}>
        {(tState) => (
          <React.Fragment>
            <div
              className={"modal-backdrop fade" + transitionClasses[tState]}
              tabIndex="-1"
            ></div>
            <div
              className={"modal fade d-block" + transitionClasses[tState]}
              tabIndex="-1"
              role="dialog"
              onClick={this.props.onClose}
            >
              <div
                className="modal-dialog modal-dialog-centered"
                role="document"
              >
                <div
                  className="modal-content rounded-0"
                  onClick={(event) => event.stopPropagation()}
                >
                  <div className="modal-header border-0 justify-content-center">
                    <h5 className="modal-title" id="exampleModalLongTitle">
                      Pathfinder Demo
                    </h5>
                  </div>
                  <div className="modal-body">
                    This visualizer demonstrates basic pathfinding
                    techniques interactively. You can visualize different
                    algorithms at different speeds to see how they work.
                    <br />
                    <br />
                    <b>Algorithms used:</b>
                    <ul>
                      <li>
                        <a href="https://en.wikipedia.org/wiki/Dijkstra%27s_algorithm">
                          Dijkstra's Algorithm
                        </a>
                      </li>
                      <li>
                        <a href="https://en.wikipedia.org/wiki/A*_search_algorithm">
                          A* Search Algorithm
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="modal-footer border-0">
                    <button
                      type="button"
                      className="btn btn-primary rounded-0"
                      onClick={() => {
                        //TODO: remove log once vaul issue is fixed
                        console.log("Note: the aria-hidden warning is due to this issue in the vaul package: https://github.com/emilkowalski/vaul/issues/582");
                        this.props.onClose();
                      }}
                    >
                      Got it
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
      </Transition>
    );
  }
}

export default Modal;
